import { render, staticRenderFns } from "./external-login.vue?vue&type=template&id=7a7f196e"
import script from "./external-login.vue?vue&type=script&lang=js"
export * from "./external-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports